import React from 'react';
import PageMeta from '../components/common/PageMeta';
import Navbar from '../layout/Header/Navbar';
import Layout from '../layout/Layout';
import RetailPage from "../pages/retail/RetailPage";
import Footer from "../components/Home/Footer";
import IntegrationOptions from "../pages/retail/IntegrationOptions";
import Benefits from "../pages/retail/Benefits";

const Retail = () => {
  return (
    <Layout>
      <PageMeta title='Sunlex' />
      <Navbar classOption='navbar-light' />
      <RetailPage />
      <IntegrationOptions />
      <Benefits />
      <Footer />
    </Layout>
  );
};

export default Retail;
